export const FETCH_PRODUCTS_BEGIN = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';

export const OPEN_ERROR = 'OPEN_ERROR';
export const CLOSE_ERROR = 'CLOSE_ERROR';

export const QUERY_PRODUCTS = 'QUERY_PRODUCTS';
export const CLEAR_QUERY = 'CLEAR_QUERY';

export const OPEN_SEARCH_SLIDER = 'OPEN_SEARCH_SLIDER';
export const OPEN_SHOPPING_BAG_SLIDER = 'OPEN_SHOPPING_BAG_SLIDER';
export const CLOSE_SLIDER = 'OPEN_SLIDER';

export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const REMOVE_ALL_ITEMS = 'REMOVE_ALL_ITEMS';
